import { escapeHtml } from '../utils/html_utils.js?v=20260706d';
import { t } from '../i18n/i18n_service.js?v=20260722a';

function openDrawingSheetCreateModal(options = {}) {
  const sheets = Array.isArray(options.sheets) ? options.sheets : [];
  const suggestedTitle = String(options.suggestedTitle || 'Zeichnung Nr. 1');
  return new Promise(resolve => {
    const root = document.createElement('div');
    root.className = 'modal-backdrop auth-modal-root drawing-sheet-modal-root';
    root.innerHTML = `
      <form class="modal confirm-modal drawing-sheet-modal" data-drawing-sheet-form>
        <div class="modal-title">${escapeHtml(t('modal.zeichnungsebene.titel.neu', 'Neue Zeichnungsebene erstellen'))}</div>
        <label class="drawing-sheet-modal-field">
          <span>${escapeHtml(t('modal.zeichnungsebene.label.name', 'Name der Zeichnungsebene'))}</span>
          <input name="drawingSheetTitle" type="text" autocomplete="off" maxlength="160" value="${escapeHtml(suggestedTitle)}">
        </label>
        <fieldset class="drawing-sheet-mode-fieldset">
          <legend>${escapeHtml(t('modal.zeichnungsebene.label.inhalt', 'Inhalt'))}</legend>
          <label class="drawing-sheet-mode-option">
            <input type="radio" name="drawingSheetMode" value="empty" checked>
            <span>${escapeHtml(t('modal.zeichnungsebene.wert.leer', 'Leere Zeichnungsebene erstellen'))}</span>
          </label>
          <label class="drawing-sheet-mode-option">
            <input type="radio" name="drawingSheetMode" value="copy">
            <span>${escapeHtml(t('modal.zeichnungsebene.wert.kopieren', 'Zeichnungsebene kopieren'))}</span>
          </label>
        </fieldset>
        <label class="drawing-sheet-modal-field" data-copy-source-field hidden>
          <span>${escapeHtml(t('modal.zeichnungsebene.label.quelle', 'Vorhandene Zeichnungsebene'))}</span>
          <select name="drawingSheetSource">
            ${sheets.map(sheet => `<option value="${escapeHtml(sheet.id)}">${escapeHtml(sheet.title)}</option>`).join('')}
          </select>
        </label>
        <div class="drawing-sheet-modal-error" data-drawing-sheet-error hidden></div>
        <div class="confirm-actions">
          <button type="button" class="btn" data-drawing-sheet-cancel>${escapeHtml(t('modal.gemeinsam.button.abbrechen', 'Abbrechen'))}</button>
          <button type="submit" class="btn primary">${escapeHtml(t('modal.zeichnungsebene.button.erstellen', 'Erstellen'))}</button>
        </div>
      </form>
    `;

    let settled = false;
    const close = value => {
      if (settled) return;
      settled = true;
      root.remove();
      resolve(value);
    };
    const syncMode = () => {
      const mode = root.querySelector('input[name="drawingSheetMode"]:checked')?.value || 'empty';
      const sourceField = root.querySelector('[data-copy-source-field]');
      const sourceSelect = root.querySelector('select[name="drawingSheetSource"]');
      const copyMode = mode === 'copy';
      if (sourceField) sourceField.hidden = !copyMode;
      if (sourceSelect) sourceSelect.disabled = !copyMode;
    };

    root.addEventListener('change', event => {
      if (event.target.matches('input[name="drawingSheetMode"]')) syncMode();
    });
    root.addEventListener('click', event => {
      if (event.target.closest('[data-drawing-sheet-cancel]')) close(null);
    });
    root.querySelector('[data-drawing-sheet-form]')?.addEventListener('submit', event => {
      event.preventDefault();
      const title = String(root.querySelector('input[name="drawingSheetTitle"]')?.value || '').trim();
      const mode = root.querySelector('input[name="drawingSheetMode"]:checked')?.value === 'copy' ? 'copy' : 'empty';
      const sourceSheetId = String(root.querySelector('select[name="drawingSheetSource"]')?.value || '');
      const error = root.querySelector('[data-drawing-sheet-error]');
      if (!title) {
        if (error) {
          error.textContent = 'Bitte einen Namen für die Zeichnungsebene eingeben.';
          error.hidden = false;
        }
        root.querySelector('input[name="drawingSheetTitle"]')?.focus();
        return;
      }
      if (mode === 'copy' && !sourceSheetId) {
        if (error) {
          error.textContent = 'Bitte eine Zeichnungsebene zum Kopieren auswählen.';
          error.hidden = false;
        }
        return;
      }
      close({ title, mode, sourceSheetId: mode === 'copy' ? sourceSheetId : null });
    });

    document.body.appendChild(root);
    syncMode();
    const titleInput = root.querySelector('input[name="drawingSheetTitle"]');
    titleInput?.focus();
    titleInput?.select();
  });
}

export { openDrawingSheetCreateModal };
